import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * TierPracticeOutline icon
 *
 * @category Tier
 */
const TierPracticeOutline = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16 4.883c4.194 0 7.6 3.394 7.6 7.598 0 .094.052.18.137.222A7.58 7.58 0 0 1 28 19.519a7.6 7.6 0 0 1-7.6 7.598 7.54 7.54 0 0 1-3.799-1.02 1.2 1.2 0 0 0-1.202 0 7.54 7.54 0 0 1-3.8 1.02A7.6 7.6 0 0 1 4 19.52a7.58 7.58 0 0 1 4.262-6.817.25.25 0 0 0 .139-.222A7.596 7.596 0 0 1 16 4.883Z M11.6 14.52 C11.02857 14.52 10.48214 14.61464 9.99107 14.79589 L9.97946 14.79857 L9.96964 14.80214 A4.98214 4.98214 0 0 0 6.59821 19.52 A5.00268 5.00268 0 0 0 13.27589 24.23071 C13.78482 24.04946 13.88661 23.42 13.61161 22.95482 A6.73214 6.73214 0 0 1 12.72768 18.67804 A6.69643 6.69643 0 0 1 13.60714 16.0825 C13.88214 15.61732 13.78036 14.98607 13.27054 14.80571 A5 5 0 0 0 11.59911 14.52 Z M23.85625 15.91007 C23.4375 15.51186 22.95196 15.85186 22.69304 16.36793 C21.90007 17.94378 20.52312 19.14773 18.85554 19.72329 C18.14239 19.98183 17.3891 20.11212 16.63054 20.10811 C16.09214 20.10811 15.45893 20.45739 15.61607 20.97257 C15.85808 21.7627 16.29215 22.48053 16.87946 23.06186 L17.06696 23.23775 L17.07054 23.24221 C17.9821 24.06845 19.16972 24.52388 20.4 24.519 C23.15982 24.519 25.4 22.27793 25.4 19.519 C25.40177 18.15511 24.84333 16.85035 23.85536 15.91007 Z M16.622 17.042 A0.685 0.685 0 0 0 15.363 17.064 A0.7 0.7 0 0 0 16 18.08 A0.698 0.698 0 0 0 16.635 17.064 z M16 7.482 C13.79834 7.48103 11.85513 8.92031 11.21429 11.02664 C11.05893 11.54271 11.62214 11.822 12.16143 11.822 C13.89179 11.822 15.48464 12.47021 16.68196 13.55414 L16.90071 13.75861 C17.43643 14.27646 17.88464 14.88539 18.22393 15.55861 C18.48375 16.07468 19.04018 16.48557 19.45804 16.08646 C20.2907 15.29391 20.82192 14.23653 20.96071 13.09539 L20.96161 13.08646 C20.9878 12.88885 21.00089 12.68706 21.00089 12.48111 C21.00089 9.71504 18.76161 7.48111 16 7.48111 Z"
        />
      </svg>
    );
  }
);

TierPracticeOutline.displayName = 'TierPracticeOutline';

export { TierPracticeOutline };
